import { render, staticRenderFns } from "./EditContent.vue?vue&type=template&id=61f6075d&scoped=true"
import script from "./EditContent.vue?vue&type=script&lang=js"
export * from "./EditContent.vue?vue&type=script&lang=js"
import style0 from "./EditContent.vue?vue&type=style&index=0&id=61f6075d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61f6075d",
  null
  
)

export default component.exports